import type { ContractRecordMap } from '@libs/data-access/entities'
import { Alert } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import { membershipsSelectors } from '@spa/scenes/Plannings/redux/selectors'
import { keyBy } from 'lodash-es'
import type { FC } from 'react'

type Props = {
  contracts: ContractRecordMap
  contractIdsError?: number[]
}

const RestCantBeCreated: FC<Props> = ({ contracts, contractIdsError = [] }) => {
  const { t } = usePlanningFormTranslation()
  const contractById = keyBy(contracts.toArray(), 'id')

  return (
    <Alert intent='semantic.red' title={t('restForm.errorCantBeCreated')}>
      {contractIdsError.map(id => {
        const membership = membershipsSelectors.useGetCachedById(
          contractById[id]?.membership_id
        )
        return (
          <div
            className='my-1 font-semibold text-semantic-red-500'
            key={id}
            data-testid='rest-cant-be-created'
          >
            {t('restForm.listedContractFullname', {
              value: {
                firstname: membership?.firstname,
                lastname: membership?.lastname
              }
            })}
          </div>
        )
      })}
    </Alert>
  )
}

export default RestCantBeCreated
